import React from 'react'
import PropTypes from 'prop-types'

class ErrorBoundary extends React.Component {
  constructor (props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError (error) {
    return { hasError: true, error }
  }

  componentDidCatch (error, info) {
    // send to console for now - replace with Sentry/LogRocket call if integrated
    // eslint-disable-next-line no-console
    console.error(`Error in ${this.props.componentName || 'component'}`, error, info)
  }

  reset = () => this.setState({ hasError: false, error: null })

  render () {
    const { hasError, error } = this.state
    const { componentName } = this.props
    if (hasError) {
      return (
        <div style={{ padding: 16, border: '1px solid #f2dede', background: '#fff7f7', color: '#a94442' }}>
          <div style={{ fontWeight: 600, marginBottom: 8 }}>Something went wrong in {componentName || 'this component'}.</div>
          <div style={{ whiteSpace: 'pre-wrap', marginBottom: 12 }}>{String(error)}</div>
          <button type='button' onClick={this.reset}>Try again</button>
        </div>
      )
    }
    return this.props.children
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
  componentName: PropTypes.string
}

export default ErrorBoundary
